/**
 * Формат: +7 9XXXXXXXXX (российские мобильные)
 * Проверяется после снятия маски
 */
export const PHONE_REGEX = /^\+7[9]\d{9}$/

/**
 * Проверка замаскированного формата: +7 (9XX) XXX-XX-XX
 */
export const PHONE_MASKED_REGEX = /^\+\d{1,3}\s?\(9\d{2}\)\s?\d{3}(-\d{2}){2}$/

export const PHONE_CONSTRAINTS = {
	/** Длина чистого номера (только цифры, с кодом страны) */
	DIGITS_LENGTH: 11,
	/** Маска для react-input-mask */
	MASK: '+9 (999) 999-99-99'
} as const
